import 'react-toastify/dist/ReactToastify.css';
import Images from './constants/Images';
import { useEffect, useState } from 'react';
import { MdEmail, MdLocationPin, MdSupportAgent } from 'react-icons/md';
import { TbWorld } from 'react-icons/tb';
import { cardDetails } from './cardDetails';
import { BiSolidContact } from 'react-icons/bi';
import { IoCall } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';

function App() {
  const [photoBase64, setPhotoBase64] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const details = [
    {
      icon: <MdEmail size={20} color={'#0C63AB'} />,
      type: 'email',
      prefix: 'mailto:',
    },
    {
      icon: <MdLocationPin size={20} color={'#0C63AB'} />,
      type: 'address',
    },
    {
      icon: <TbWorld size={20} color={'#0C63AB'} />,
      type: 'website',
      prefix: 'website',
    },
    {
      icon: <IoCall size={20} color={'#0C63AB'} />,
      type: 'phone',
      prefix: 'tel:',
    },
    {
      icon: <MdEmail size={20} color={'#0C63AB'} />,
      type: 'infoEmail',
      prefix: 'mailto:',
    },
    {
      icon: <MdSupportAgent size={20} color={'#0C63AB'} />,
      type: 'altPhone',
      prefix: 'tel:',
    },
  ];
  useEffect(() => {
    let name = queryParams.get('uid');
    setSelectedUserId(name);
  }, []);

  useEffect(() => {
    let data = cardDetails?.find((item, index) => item?.uid == selectedUserId);
    if (data) {
      setSelectedUser(data);
    }
  }, [selectedUserId]);

  const getUserDetails = (type) => {
    if (selectedUser) {
      let details = Object.entries(selectedUser)?.find(
        (item, index) => item[0] == type,
      );
      if (details?.length) {
        return details[1];
      }
    }
    return null;
  };

  useEffect(() => {
    if (selectedUser) {
      fetch(selectedUser.photo)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => setPhotoBase64(reader.result.split(',')[1]);
          reader.readAsDataURL(blob);
        })
        .catch((error) => console.error('Error loading image:', error));
    }
  }, [selectedUser]);

  const generateVCard = (contactDetails) => {
    const vCardData = `BEGIN:VCARD\nVERSION:3.0\nFN:${contactDetails.name}\nTITLE:${contactDetails.role}\nTEL;TYPE=mobile,voice:${contactDetails.phone}\nEMAIL:${contactDetails.email}\nADR;TYPE=Address:${contactDetails.address}\nURL:${contactDetails.website}\nEMAIL:${contactDetails.infoEmail}\nTEL;TYPE=support,voice:${contactDetails.altPhone}\nPHOTO;ENCODING=b;TYPE=PNG:${photoBase64}\nBACKGROUND;ENCODING=b;TYPE=PNG:${photoBase64}\nEND:VCARD`;

    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'contact.vcf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleClick = (item, data) => {
    if (item?.prefix == 'website') {
      navigateToWebsite(data);
    } else {
      window.location.href = `${item?.prefix}:${data}`;
    }
  };

  const navigateToWebsite = (data) => {
    if (data) {
      if (data.includes('https://')) {
        window.open(data, '_blank');
      } else {
        window.open(`https://${data}`, '_blank');
      }
    }
  };
  if (!selectedUser) {
    return (
      <div className="flex flex-col h-[100vh] bg-gray-200 items-center justify-center p-[20px]">
        <img src={Images.noProfile} className="sm:max-w-[500px]" />
        <h2 className="text-black font-bold">No Profile Found !</h2>
      </div>
    );
  }
  if (selectedUser) {
    return (
      <>
        <div className="flex flex-1 flex-col pb-[50px]">
          <div className="relative w-full">
            <img
              src={Images.bcpback}
              className="w-full md:h-[50vh]  object-contain"
            />
            <div className="h-[100px] w-[100px] border-[2px] border-[#FFF] shadow-lg overflow-hidden absolute left-1/2 rounded-full -translate-x-1/2  -bottom-[60px]  ">
              <img
                src={selectedUser?.photo}
                className="object-contain bg-white"
              />
            </div>
          </div>
          <div className="mt-[60px] flex flex-1 items-center flex-col justify-center">
            <h1 className="font-bold text-[#0C63AB] mt-[10px]">
              {selectedUser?.name}
            </h1>
            <h1 className="font-semibold mt-1 text-[#0C63AB]">
              {selectedUser?.role}
            </h1>
            <div className="text-[14px] text-center text-gray-400 mt-[15px] mb-[10px]">
              Your Trusted Partner in Construction Excellence
            </div>
          </div>
          <div className="flex flex-1 items-center sm:justify-center">
            <div className="p-[10px] flex  flex-col  ">
              {details?.map((item, index) => {
                const data = getUserDetails(item?.type);
                if (data) {
                  return (
                    <div
                      onClick={() => {
                        handleClick(item, data);
                      }}
                      className="flex flex-1 gap-2 items-center   mb-2"
                    >
                      <div>{item.icon}</div>
                      <div className="text-[13px] text-gray-600">{data}</div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </div>
        <div className="fixed w-full bg-black  items-center justify-center flex">
          <div
            onClick={() => {
              generateVCard(selectedUser);
            }}
            className="bg-[#0C63AB]  font-normal cursor-pointer  p-[10px] text-white rounded-full fixed bottom-[15px] "
          >
            <div className="flex w-full  flex-1 flex-row ">
              <BiSolidContact size={20} />
              <div className="flex flex-1 w-full ml-1">Add to Contact</div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;
